// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-funnel';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M11.448 11.808H6.552v5.616h4.896zm3.96-8.64L17.424.576H.576l2.016 2.592zM4.392 7.992l2.16 3.816h4.896l2.16-3.816zm11.016-4.824-1.8 4.824H4.392l-1.8-4.824z'
  />
);

export const viewBox = '0 0 18 18';
